<template>
    <div class="field floating-label">
        <input :placeholder="label" :name="name" :id="name"
               :type="type" class="input" :class="{ 'is-danger': errors.hasError( name ) }"
               :required="required" v-model="input">
        <label :for="name" class="label" v-text="label"></label>
        <p class="help is-danger" v-text="errors.get(name)"></p>
    </div>
</template>
<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: false,
                default: 'text'
            },
            errors: {
                type: Object,
                required: false
            },
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            value: null
        },
        mounted() {
            this.input = ( this.value ) ? this.value : '';
        },
        data() {
            return {
                input: ''
            }
        },
        watch: {
            input( input ) {
                if(input) this.errors.clear( this.name );
                this.$emit('input', input)
            },
            value( value ) {
                this.input = value
            }
        }
    }
</script>
